import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_tabs, {
    "tab-position": _ctx.tabPosition,
    style: {
      "height": "1000px"
    },
    onTabClick: $setup.handleClick
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
      label: "正在上传",
      name: "uploading"
    }), _createVNode(_component_el_tab_pane, {
      label: "正在下载",
      name: "downloading"
    }), _createVNode(_component_el_tab_pane, {
      label: "传输完成",
      name: "finished"
    })]),
    _: 1
  }, 8, ["tab-position", "onTabClick"])]);
}